import React from 'react';
import DiscoverPage from './DiscoverPage';

// NOTE: This embed page is DISPLAY-ONLY — designed for iframe embedding on the website.
// No wallet connection required. Same pattern as EmbedVerifyPage / EmbedRewardsPage.
export const EmbedDiscoverPage = () => <DiscoverPage embed={true} />;
